import { Injectable } from '@angular/core';
import { UserWizardService } from '../../../services/user/user.wizard.service';
import { ApiService, InputDatastoreService, CountryListService, DialogService, UserService, ValuesExchangeProvider } from '@nrwl/common-lib';

@Injectable()
export class UserFromGroupWizardService extends UserWizardService {

  constructor(apiService: ApiService,
              inputDatastoreService: InputDatastoreService,
              countryListService: CountryListService,
              dialogService: DialogService,
              readonly userService: UserService,
              valuesExchange: ValuesExchangeProvider) {
                super(apiService, inputDatastoreService, countryListService, dialogService, userService, valuesExchange);
  }

  //------------------------------------------------ Wizard control ----------------------------------------------------

  onFinish() {
    const responseProcessed = this._saveWizardData();
    responseProcessed.subscribe(() => {
      this.currentStep = this.finishingStep;
      if (!this.requestFailed) {
        this.successMessage = "Groups have been successfully removed";
        this.valuesExchange.notifyListeners("user_admin_board", { value: 'update', cacheBreaker: Date.now() });
      }
    });
    return responseProcessed;
  }

  _handleErrorResponse(response) {
    this.errorMessage = 'Groups were not removed';

    if (response && response.error && response.error.errors.length !== 0) {
      this.errorDescription = response.error.errors[0];
    }
  }
}
